import Enum from "./Enum";

export default Enum.create( {
	/** @deprecated */
	COMMITMENT: "ACTION_ITEM",
	ACTION_ITEM: "ACTION_ITEM",
	PERSONAL_ACTION_ITEM: "PERSONAL_ACTION_ITEM",
	DECISION: "DECISION",
	NOTE: "SUMMARY",
	CONCLUSION: "CONCLUSION",
} );
